﻿export class ScreenLoadError {
    constructor(public exception: any) {}

    static eventName() { return 'ScreenLoadError'; }

    eventName = ScreenLoadError.eventName;
}